import { axiosInstance } from "../../../util/axios";
import {
  getUIConfigBaseUrlSelector,
  getMenuUIConfigBaseUrlSelector,
  getUIConfigAuthToken,
} from "../../../Api/ApiHelper";

const fetchMenuQuery = "&fields=*,icon.data.full_url*,barcode_en.data.full_url*,barcode_ar.data.full_url*,click_me_icon.data.full_url*";

export const fetchUIConfig = () => {
  const url = getUIConfigBaseUrlSelector();
  const authToken = getUIConfigAuthToken();
  return axiosInstance.get(url, {
    headers: {
      Authorization: `bearer ${authToken}`,
    },
  });
};

export const fetchMenuUIConfig = () => {
  let url = getMenuUIConfigBaseUrlSelector();
  const authToken = getUIConfigAuthToken();
  url = `${url}${fetchMenuQuery}`;
  return axiosInstance.get(url, {
    headers: {
      Authorization: `bearer ${authToken}`,
    },
  });
};
